module.exports = __webpack_public_path__ + "static/media/sensable_87.1fd3a591.jpg";